import styled from "styled-components";

const UpgradeGuestMembershipActionPopupCss = styled.div`
    position: fixed;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    min-width: 220px;
    background-color: white;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border: 3px solid #0A5587;
    padding: 5px 10px 10px 10px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);  
    text-align:center;
    z-index:9;
    h4{
      font-size: 20px;
      color: #005586;
      font-weight:700;
      margin-bottom:5px
    }
    ul li{
      font-size: 18px;
    } 
    button{
      border-radius: 5px;
      background: #61b01f;
      background: -moz-linear-gradient(top,#61b01f 0%,#27911b 100%);
      background: -webkit-linear-gradient(top,#61b01f 0%,#27911b 100%);
      background: linear-gradient(to bottom,#61b01f 0%,#27911b 100%);
      color: #fff;
      font-size: 16px;
      min-width: 130px;
      align-items: center;
      cursor: pointer;
      border: none;
      padding:6px;
    }
   
   
    @media (min-width: 1441px) {
      width: fit-content;
        margin-left: calc(50vw - 726px);
      h4{
      font-size: 16px;
     
    }
    ul li{
      font-size: 13px;
    }
    button {
      font-size: 13px;
    }
    }
    @media (max-width: 992px) {
      min-width: auto;
      > img {
        width: 70px;
      }
      > button {
        padding: 4px;
        border-radius: 4px;
        font-size: 13px;
    min-width: 127px;
      }
      h4 {
        font-size: 16px;
      }
      > ul {
        margin-bottom: 10px;
         li {
    font-size: 12px;
}
      }
        h3 {
          font-size: 16px;
        }
    }
`


export { UpgradeGuestMembershipActionPopupCss};
